import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    description: 'Description for the save shipping default button',
    defaultMessage: 'Save as default shipping configuration for this product.',
    id: 'HFTTGU',
  },
  buttonText: {
    description: 'Text for the save shipping default button',
    defaultMessage: 'Save',
    id: 'ctqo6k',
  },
  saved: {
    description: 'Text displayed when shipping defaults are successfully saved',
    defaultMessage: 'Saved!',
    id: 'N38zRg',
  },
});

export default messages;
